
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { BoardCategory } from '@/types/board';

interface BoardHeaderProps {
  activeCategory: BoardCategory;
  user: any | null;
  handleWritePost: () => void;
}

const BoardHeader = ({ activeCategory, user, handleWritePost }: BoardHeaderProps) => {
  const renderWriteButton = () => {
    if (activeCategory === 'Weee Link 공유') {
      // For Weee Link, anyone can share
      return (
        <Button onClick={handleWritePost}>
          <PlusCircle className="mr-2 h-4 w-4" />
          링크 공유하기
        </Button>
      );
    } else {
      // For other categories, require login
      if (user) {
        return (
          <Button onClick={handleWritePost}>
            <PlusCircle className="mr-2 h-4 w-4" />
            글쓰기
          </Button>
        );
      } else {
        return (
          <Button asChild>
            <Link to="/login">로그인 후 글쓰기</Link>
          </Button>
        );
      }
    }
  };

  return (
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-2xl font-semibold">{activeCategory}</h2>
      {renderWriteButton()}
    </div>
  );
};

export default BoardHeader;
